exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#settings-page[data-v-50fe3b24] {\n    max-width: 1280px;\n}\n", ""]);

// exports
